// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.

// You can define here the tab components mapping for the custom parameters group of your solution
export const CUSTOM_PARAMETERS_GROUPS_COMPONENTS_MAPPING = {
  // parametersGroupId: CustomScenarioParametersTabComponent,
};
